export function sameStringArray(left: readonly string[], right: readonly string[]) {
	if (left.length !== right.length) {
		return false;
	}

	const sortedLeft = [...left].sort();
	const sortedRight = [...right].sort();

	return sortedLeft.every((value, index) => value === sortedRight[index]);
}

export function arrayParamKey(values: readonly string[]) {
	return values.join(",");
}
